import { observable } from 'mobx'

import { DBObject } from './DBObject'

export class TrashCan {
    @observable items: Map<string, DBObject> = new Map()
}
